import { Scope } from '@pubstack/common/src/scope'
import { useEffect, useRef } from 'react'
import { useHref, useLocation } from 'react-router-dom'
import { useAuthenticatedUser } from '~/auth/user.hooks'
import { reloadOnScope, useSwitchScope } from '~/hooks/useSwitchScope'
import { resolveScopeId, scopeFromPath, shortScopeId } from '~/utils/scope-path'

const SWITCH_ATTEMPT_KEY = 'pubstack-scope-path-switch'

export const useScopeInPath = (scopes: Scope[]) => {
  const user = useAuthenticatedUser()
  const basename = useHref('/')
  const location = useLocation()
  const switchScope = useSwitchScope()
  const leaving = useRef(false)
  const urlApplied = useRef(false)

  useEffect(() => {
    if (leaving.current) return
    const accessible = Array.isArray(scopes) ? scopes : []
    const requested = scopeFromPath(basename)
    const targetId = requested ? resolveScopeId(requested, accessible) : undefined
    const fromUrl = !urlApplied.current
    urlApplied.current = true

    if (fromUrl && targetId && targetId !== user.currentScopeId && sessionStorage.getItem(SWITCH_ATTEMPT_KEY) !== targetId) {
      leaving.current = true
      sessionStorage.setItem(SWITCH_ATTEMPT_KEY, targetId)
      void switchScope(targetId)
      return
    }
    sessionStorage.removeItem(SWITCH_ATTEMPT_KEY)

    if (!accessible.some((scope) => scope.id === user.currentScopeId)) return
    const short = shortScopeId(user.currentScopeId, accessible)
    if (requested !== short && scopeFromPath(`/${short}`)) {
      leaving.current = true
      reloadOnScope(short, location)
    }
  }, [basename, user.currentScopeId, scopes])
}
